<template>
  <a-select
    style="width: 100%"
    v-model="country"
    @change="handleChange"
    show-search
    :filter-option="filterOption"
    option-filter-prop="children"
    allowClear
    placeholder="请选择国家"
    :size="size"
    :disabled="disabled"
  >
    <a-select-option v-for="item in countryOptions" :key="item.countryCode" :value="item.countryCode">
      {{ item.countryName }}
    </a-select-option>
  </a-select>
</template>

<script>
import { queryCountryOptionsApi } from '@/api/Site/Create'
export default {
  data() {
    return {
      countryOptions: [],
      country: ''
    }
  },
  props: {
    value: {},
    size: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.queryCountryOptions()
  },
  methods: {
    async queryCountryOptions() {
      let res = await queryCountryOptionsApi()
      let { code, msg, extra } = res
      if (code == '200') {
        this.countryOptions = extra.countrys
      } else {
        this.$message.error(msg)
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(val) {
      this.$emit('input', val)
    }
  },
  watch: {
    value: {
      handler() {
        this.country = this.value
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped></style>
